export const connectToRequestContainerData = [
  {
    Question: `How do I connect with you quickly to request a Container Repair?`,
    Answer: `Need a quick way to schedule a Container Repair?  

        If you are a residential customer:  
        
        <ul><li><a href=’https://www.wm.com/us/en/user/login’>Log in</a> to your My WM account</li> 
        
        <li> From the Dashboard, select Manage My Services</li> 
        
        <li>Select the Container Issue and submit your request</li> </ul> 
        
        If you are a commercial customer, please <a href=’https://www.wm.com/us/en/support#support’> Contact Us.</a>`,
  },
]
